const pattern_eng = /[a-zA-Z]/;
const pattern_num = /[0-9]/;
const pattern_kor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
const pattern_spc = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/;
const pattern_mobile = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})/;
const pattern_eng_small = /[a-z]/;
const pattern_email = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;


/** 이름 유효성 검사  */
export const validateName = (name) => {
  if (pattern_spc.test(name)) return false;
  if (pattern_num.test(name)) return false;

  return pattern_eng.test(name) || pattern_kor.test(name);
};

/** 휴대폰 번호 유효성 검사 */
export const validateMobile = (mobileNo) => {
  if (pattern_spc.test(mobileNo)) return false;

  return pattern_mobile.test(mobileNo);
};

/** 아이디 유효성 검사 */
export const validateUserId = (userId) => {
  if (userId.length < 5 || userId.length > 20) return false; // 길이가 5자 이상, 20자 이하가 아닌 경우
  if (pattern_kor.test(userId)) return false; // 한글이 포함된 경우
  if (pattern_spc.test(userId)) return false; // 특수문자가 포함된 경우
  return pattern_eng_small.test(userId) && pattern_num.test(userId);
};

/** 비밀번호 유효성 검사 */
export const validatePassword = (password) => {
  if (password.length < 8 || password.length > 15) return false; // 길이가 8자 이상, 15자 이하가 아닌 경우
  if (!pattern_eng.test(password)) return false; // 영어가 포함되지 않은 경우
  if (!pattern_num.test(password)) return false; // 숫자가 포함되지 않은 경우
  if (!pattern_spc.test(password)) return false; // 특수문자가 포함되지 않은 경우
  if (pattern_kor.test(password)) return false; // 한글이 포함된 경우
  return true;
};

/** 이메일 유효성 검사 */
export const emailValidationCheck = (email) => {
  return pattern_email.test(email);
};